import React, { useEffect, useState } from "react";
import { IoCameraOutline } from "react-icons/io5";
import { MdClose } from "react-icons/md";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { getApiCaller } from "../../../../../../../Libs/apiCaller";

export default function ChannelUpload({
  setCreateNewChannelSection,
  newChannel,
  setNewChannel,
}) {
  const formik = useFormik({
    initialValues: {
      channelName: newChannel.channelName,
      description: newChannel.description,
    },
    validationSchema: Yup.object({
      channelName: Yup.string()
        .required("Channel Name is required")
        .test("no-blank", "Channel Name cannot be empty", (value) =>
          value?.trim() ? true : false
        )
        .min(3, "Channel Name must be at least 3 characters"),
    }),
    onSubmit: async (values) => {
      // if (!image) {
      //   setImageError("Image is required");
      //   return;
      // }
      // setImageError(""); // clear error if image exists
      setNewChannel((prev) => ({
        ...prev,
        ...values,
        image: image ? image : null,
      }));
      const endPoint = `channel/slug?channelName=${values.channelName}`;
      const response = await getApiCaller(endPoint);
      if (response?.status === 200) {
        setNewChannel((prev) => ({ ...prev, slug: response.data.data }));
        setCreateNewChannelSection(3);
      } else {
        toast.error(response?.response?.data?.message || response?.message);
      }
    },
  });

  useEffect(() => {
    if (newChannel?.image) {
      setImage(newChannel?.image);
      setImagePreview(URL.createObjectURL(newChannel?.image));
    }
  }, []);
  const [imageError, setImageError] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB
      if (fileSizeInMB > 5) {
        setImageError("Image size should be less than 5MB.");
      } else {
        setImage(file);
        setImagePreview(URL.createObjectURL(file));
        setImageError("");
      }
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
    setImagePreview(null);
    // setImageError("Image is required");
  };

  const handleDone = () => {
    setCreateNewChannelSection(3);
    // onGroupDone(); // 👈 navigate to ChannelType screen
    // Add form submission logic here
  };

  return (
    <div className="bg-white">
      <div className="my-4 w-[130px] h-[130px] mx-auto rounded-4xl border border-dashed border-[#000] overflow-hidden relative">
        <label
          htmlFor="imageUpload"
          className="cursor-pointer w-full h-full flex items-center justify-center"
        >
          {imagePreview ? (
            <img
              src={imagePreview}
              alt="Group"
              className="w-full h-full object-cover rounded-4xl"
            />
          ) : (
            <IoCameraOutline className="text-[#7104F8] text-3xl" />
          )}
        </label>

        {imagePreview && (
          <button
            type="button"
            onClick={handleRemoveImage}
            className="absolute top-1 right-1 bg-[var(--primary-color)] rounded-full p-1 shadow"
          >
            <MdClose className="text-white text-xl" />
          </button>
        )}
        <input
          type="file"
          id="imageUpload"
          accept=".jpg,.png"
          value=""
          onChange={handleImageChange}
          className="hidden"
        />
      </div>
      {imageError && (
        <p className="text-center -mt-1 text-red-500 text-xs">{imageError}</p>
      )}
      <form onSubmit={formik.handleSubmit}>
        <div className="mb-4">
          <label className="block text-sm text-gray-500 font-normal mb-1">
            Channel Name
          </label>
          <input
            type="text"
            name="channelName"
            placeholder="Enter Channel Name"
            value={formik.values.channelName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            maxLength={30}
            className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {formik.touched.channelName && formik.errors.channelName && (
            <p className="text-red-500 text-xs mt-1">
              {formik.errors.channelName}
            </p>
          )}
        </div>

        <div className="mb-4">
          <label className="block text-gray-500 text-sm font-normal mb-1">
            Description
          </label>
          <textarea
            name="description"
            placeholder="Enter Description"
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full border rounded-lg px-3 py-2 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {formik.touched.description && formik.errors.description && (
            <p className="text-red-500 text-xs mt-0">
              {formik.errors.description}
            </p>
          )}
        </div>

        <button
          // onClick={() => {
          //   if (!image) {
          //     setImageError("Image is required");
          //     return;
          //   }
          // }}
          type="submit"
          className="btn btn-default bg-[var(--primary-color)] text-white w-full h-12 font-normal rounded-full border-0"
        >
          Next
        </button>
      </form>
    </div>
  );
}
